/**
 * Picks the prescription trade name a trade name may use (CY-368): one of its own substance, or a new one.
 * A name that only exists under another substance is refused, so another drug's stock never mixes in.
 */
export function resolvePrescribedNameForSubstance(candidates, substance) {
    const own = candidates.find(candidate => candidate.drugCatalogItemId === substance.id);
    if (own)
        return { kind: 'existing', id: own.id };
    const [other] = candidates;
    if (!other)
        return { kind: 'create' };
    return {
        kind: 'conflict',
        message: `Prescription trade name "${other.name}" belongs to ${other.drugName ?? 'another substance'}, not to ${substance.name}`,
    };
}
//# sourceMappingURL=prescribed-name.js.map